var _path, _path2, _path3, _path4, _defs;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFbMsg = function SvgFbMsg(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 16.1899C34 25.1316 26.3925 32.3797 17 32.3797C15.5967 32.3797 14.2375 32.2186 12.9336 31.9114C12.5384 31.8185 12.1253 31.8542 11.7615 32.0318L8.041 33.8493C7.0805 34.3183 5.95 33.6359 5.95 32.5864V29.2447C5.95 28.7673 5.73155 28.3223 5.37115 28.0001C2.06125 25.0445 0 20.8476 0 16.1899C0 7.24807 7.6075 0 17 0C26.3925 0 34 7.24807 34 16.1899Z",
    fill: "url(#paint0_radial_2_14)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M26.3432 11.0357C25.9794 11.0357 25.6266 11.1536 25.3232 11.3769L20.4833 14.8764C20.3702 14.9594 20.2453 15.0009 20.1135 15.0009C19.986 15.0009 19.8662 14.9619 19.765 14.888L16.3888 12.4056C15.702 11.9066 14.8928 11.6434 14.0454 11.6434C12.7058 11.6434 11.4741 12.3001 10.7508 13.4002L9.72145 14.9702L6.21945 20.5287C5.88625 21.0385 5.86075 21.6678 6.1591 22.2009C6.4634 22.7438 7.038 23.0809 7.6585 23.0809C8.0223 23.0809 8.37505 22.963 8.6785 22.7397L13.5184 19.2402C13.6314 19.1572 13.7564 19.1157 13.8881 19.1157C14.0156 19.1157 14.1355 19.1547 14.2366 19.2286L17.6128 21.711C18.3005 22.2108 19.1088 22.4732 19.9563 22.4732C21.2959 22.4732 22.5275 21.8165 23.2509 20.7164L24.2802 19.1464L27.7822 13.5879C28.1154 13.0781 28.1409 12.4488 27.8426 11.9157C27.5383 11.3728 26.9637 11.0357 26.3432 11.0357Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M26.3432 11.4508C26.072 11.4508 25.8077 11.5396 25.579 11.7082L20.7366 15.2102C20.553 15.3455 20.3388 15.4161 20.1144 15.4161C19.8942 15.4161 19.686 15.348 19.5109 15.2201L16.1338 12.7368C15.5227 12.2927 14.801 12.0585 14.0454 12.0585C12.8511 12.0585 11.7538 12.6439 11.1086 13.6252L10.0801 15.1952L6.5824 20.7479C6.32995 21.134 6.3104 21.6056 6.5331 22.0024C6.7592 22.4059 7.20205 22.6666 7.65935 22.6666C7.9305 22.6666 8.19485 22.5778 8.4235 22.4092L13.2659 18.9073C13.4495 18.7719 13.6637 18.7014 13.8881 18.7014C14.1083 18.7014 14.3165 18.7694 14.4916 18.8973L17.8687 21.3806C18.4798 21.8248 19.2015 22.0589 19.9571 22.0589C21.1514 22.0589 22.2487 21.4736 22.8939 20.4922L23.9224 18.9222L27.4201 13.3695C27.6726 12.9834 27.6921 12.5118 27.4694 12.115C27.2433 11.7115 26.8013 11.4508 26.3432 11.4508Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8349 12.0394L20.9899 15.5431C20.4714 15.925 19.7659 15.925 19.2559 15.5514L15.878 13.0681C14.45 12.0303 12.427 12.3873 11.4665 13.8485L10.438 15.4177L6.94451 20.9638C6.43451 21.7442 7.41201 22.6326 8.16851 22.0763L13.0135 18.5726C13.532 18.1907 14.2375 18.1907 14.7475 18.5643L18.1254 21.0476C19.5534 22.0854 21.5764 21.7284 22.5369 20.2672L23.5654 18.698L27.0589 13.1519C27.5689 12.3715 26.5914 11.4831 25.8349 12.0394Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2_14",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.02395 32.3614) scale(40.4702 39.5298)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1292FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.079,
    stopColor: "#2982FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#4E69FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351,
    stopColor: "#6559FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.428,
    stopColor: "#6D53FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.754,
    stopColor: "#DF47AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.946,
    stopColor: "#FF6257"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFbMsg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/fb_msg.872fb8ce.svg";
export { ForwardRef as ReactComponent };